

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const APIKEY ='47a7950f-c1b2-48d7-b990-dab3c296ad28';
export const MODAL_CLOSE_SEC = 2.5;
export const NUTRI_KEY = '33bf7e53438545b7bfe795e427f89e62';


